<template>
  <div>
    <NotificationMessage class="notification" />
    <div class="layout">
      <CrudDesks
        class="crud-data-table"
        :center="center"
        :room="room"
        :desks="desks"
      />
    </div>
  </div>
</template>

<script>
import NotificationMessage from "@/components/components-base/notification/NotificationMessage";
import CrudDesks from "@/components/components-salles/admin/crud/desk/CrudDesks";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DesksCrudView",
  components: {
    NotificationMessage,
    CrudDesks,
  },
  computed: {
    ...mapGetters("centerModule", { centerById: "getCenterById" }),
    ...mapGetters("roomModule", { roomById: "getRoomById" }),
    ...mapGetters("deskModule", { desks: "getDesks", deskById: "getDeskById" }),
    center() {
      return this.centerById(parseInt(this.$route.params.centerId));
    },
    room() {
      return this.roomById(parseInt(this.$route.params.roomId));
    },
  },
  methods: {
    ...mapActions("deskModule", ["loadDesksWithDependents"]),
  },
  async mounted() {
    await this.loadDesksWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: absolute;
  padding: 0 1.5rem;
  z-index: 100;
}

.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.crud-data-table {
  margin: 3rem auto;
  width: 90%;
}

.crud-update {
  display: flex;
  justify-content: center;
  padding: 2rem 0 0 0;
}
</style>
